import { render, staticRenderFns } from "./Score.vue?vue&type=template&id=9a5842f4&scoped=true"
import script from "./Score.vue?vue&type=script&lang=js"
export * from "./Score.vue?vue&type=script&lang=js"
import style0 from "./Score.vue?vue&type=style&index=0&id=9a5842f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a5842f4",
  null
  
)

export default component.exports